import React from "react";
import "./style.module.scss";
import { images } from "helpers/images";

export default function Noimage({ height, width, className }) {
  return (
    <img
      src={images.noimg1}
      height={height}
      width={width}
      className={className}
      alt=""
    />
  );
}
